import { Link } from "@curie/react"
import { CurieLogo, IconStartTrialCampaign } from "../icons"
import { CampaignButton } from "./CampaignButton"
import CampaignNavBarDropDown from "./CampaignNavBarDropDown"


const productMenuItems = [
  { label: 'All Products', href: 'https://www.curietech.ai/product' },
  { label: 'Coding Agents', href: 'https://www.curietech.ai/product/coding-agents' },
  { label: 'Testing Agents', href: 'https://www.curietech.ai/product/testing-agents' },
  { label: 'Documentation Agents', href: 'https://www.curietech.ai/product/documentation-agents' },
  { label: 'Code Insight Agents', href: 'https://www.curietech.ai/product/code-insight-agents' },
  { label: 'Migration Agents', href: 'https://www.curietech.ai/product/migration-documentation-agent' },
  { label: 'Security', href: 'https://www.curietech.ai/security' },
]

const resourceMenuItems = [
  { label: 'Blog', href: 'https://www.curietech.ai/blog' },
  { label: 'Guide to MuleSoft Security', href: 'https://www.curietech.ai/mulesoft-integration/mulesoft-security' },
]

const companyMenuItems = [
  { label: 'About', href: 'https://www.curietech.ai/about' },
  { label: 'Careers', href: 'https://www.curietech.ai/careers' },
  { label: 'Contact', href: 'https://www.curietech.ai/contact-us' },
]

export const CampaignNavBar = () => {
  return (
    <nav className="absolute left-0 right-0 h-16 flex justify-center items-center w-full">
      <Link href='https://www.curietech.ai/' className='flex items-center'>
        <CurieLogo className='text-light-on-background absolute left-64 w-24 h-16' />
      </Link>
      <div className="absolute right-64 space-x-4 flex items-center">
        <Link href='https://www.curietech.ai/' className='flex items-center'>
          <span className="text-black font-medium">Login</span>
        </Link>
        <CampaignButton
          className='text-light-on-background px-2 py-4 rounded-full disabled:opacity-60'
          onClick={() => window.open('https://platform.curietech.ai/signup', '_blank')}
        >
          <div className='flex flex-row items-center'>
            <span className="text-lg font-medium">Sign up for Free</span>
          </div>
        </CampaignButton>
      </div>
      <div className="flex text-xl w-full h-full justify-center items-center bg-white space-x-1">
        <CampaignNavBarDropDown title="Why Curie" menuItems={[]} url="https://www.curietech.ai/curie-vs-copilots" />
        <CampaignNavBarDropDown title="Product" menuItems={productMenuItems} type="product" />
        <CampaignNavBarDropDown title="Use Cases" menuItems={[]} type="usecases" />
        <CampaignNavBarDropDown title="Resources" menuItems={[]} type="resources" />
        <CampaignNavBarDropDown title="Company" menuItems={[]} type="company" />
        <CampaignNavBarDropDown title="Pricing" menuItems={[]} url="https://www.curietech.ai/pricing" />
      </div>
    </nav>
  )
}

export default CampaignNavBar